import { convertToCents, dollars, numberWithCommas, toCurrency, toDate, toSmartCurrency } from "../js/utilities/filters";

const Filters = {
  install: Vue => {
    Vue.filter('toCurrency', toCurrency);
    Vue.filter('toSmartCurrency', toSmartCurrency);
    Vue.filter('dollars', dollars);
    Vue.filter('toDate', toDate);
    Vue.filter('numberWithCommas', numberWithCommas);
    Vue.filter('convertToCents', convertToCents);
  }
}

export default Filters;
